module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_01@2x-1e976cf0f7be69561ee8b152d7c431ce.jpg";